module.exports = __webpack_public_path__ + "static/media/icon_kayak.4efbdbc6.svg";